/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountDetailH2hEntity } from '../models/AccountDetailH2hEntity';
import type { BidvBankTransferWhitelistEntity } from '../models/BidvBankTransferWhitelistEntity';
import type { DomesticBankListH2hEntity } from '../models/DomesticBankListH2hEntity';
import type { LookupAccountDto } from '../models/LookupAccountDto';
import type { SubmitTransferDto } from '../models/SubmitTransferDto';
import type { SubmitTransferEntity } from '../models/SubmitTransferEntity';
import type { SyncTransactionDto } from '../models/SyncTransactionDto';
import type { TransferStatusEntity } from '../models/TransferStatusEntity';
import type { UpdateBidvBankTransferWhitelistDto } from '../models/UpdateBidvBankTransferWhitelistDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BidvBankTransferService {
  /**
   * Gửi yêu cầu chuyển tiền BIDV
   * @param requestBody
   * @returns SubmitTransferEntity
   * @throws ApiError
   */
  public static bidvBankTransferControllerSubmitTransfer(
    requestBody: SubmitTransferDto,
  ): CancelablePromise<SubmitTransferEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv/bank-transfer/submit',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Tra cứu trạng thái chuyển tiền
   * @param transactionCode Transaction code
   * @returns TransferStatusEntity
   * @throws ApiError
   */
  public static bidvBankTransferControllerGetTransferStatus(
    transactionCode: string,
  ): CancelablePromise<TransferStatusEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/bidv/bank-transfer/status/{transactionCode}',
      path: {
        transactionCode: transactionCode,
      },
    });
  }

  /**
   * Đối soát thủ công giao dịch chuyển tiền BIDV
   * @param requestBody
   * @returns TransferStatusEntity
   * @throws ApiError
   */
  public static bidvBankTransferControllerSyncTransaction(
    requestBody: SyncTransactionDto,
  ): CancelablePromise<TransferStatusEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv/bank-transfer/sync-transaction',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Tra cứu tên người thụ hưởng
   * @param requestBody
   * @returns AccountDetailH2hEntity
   * @throws ApiError
   */
  public static bidvBankTransferControllerLookupAccount(
    requestBody: LookupAccountDto,
  ): CancelablePromise<AccountDetailH2hEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv/bank-transfer/lookup-account',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Danh sách ngân hàng nội địa
   * @param code Mã ngân hàng
   * @param transferMethod Phương thức chuyển tiền: I = Chuyển khoản trong ngân hàng, O = Chuyển khoản liên ngân hàng, F = Chuyển khoản nhanh
   * @param page Trang hiện tại (bắt đầu từ 1)
   * @param limit Số bản ghi mỗi trang
   * @returns DomesticBankListH2hEntity
   * @throws ApiError
   */
  public static bidvBankTransferControllerListDomesticBanks(
    code?: string,
    transferMethod?: 'I' | 'O' | 'F',
    page: number = 1,
    limit: number = 20,
  ): CancelablePromise<DomesticBankListH2hEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/bidv/bank-transfer/domestic-banks',
      query: {
        code: code,
        transferMethod: transferMethod,
        page: page,
        limit: limit,
      },
    });
  }

  /**
   * Xem danh sách whitelist chuyển tiền BIDV
   * @returns BidvBankTransferWhitelistEntity
   * @throws ApiError
   */
  public static bidvBankTransferControllerGetBidvBankTransferWhitelist(): CancelablePromise<BidvBankTransferWhitelistEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/bidv/bank-transfer/whitelist',
    });
  }

  /**
   * Cập nhật danh sách whitelist chuyển tiền BIDV
   * @param requestBody
   * @returns BidvBankTransferWhitelistEntity
   * @throws ApiError
   */
  public static bidvBankTransferControllerUpdateBidvBankTransferWhitelist(
    requestBody: UpdateBidvBankTransferWhitelistDto,
  ): CancelablePromise<BidvBankTransferWhitelistEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/bidv/bank-transfer/whitelist',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
